import React, { useState } from "react";
import rootStyle from "../AdminRoot/RootStyle.module.css";
import appDetailStyle from "../Overview/AppDetail.module.css";
import { TbCategory } from "react-icons/tb";
import { users } from "../../Home/users";
import SidebarList from "../../SideData/Sidebar/SidebarList";

import { GrFormNext } from "react-icons/gr";

import { adminItmList } from "./adminItmList";
import { Logo } from "../../Iocn/iocn";
import { useHistory } from "react-router-dom";

export const AdminSidebarMenu = ({
  activeItemId,
  setActiveItemId,
  appData,
  toggleSidebar
}) => {

  const [isRotated, setIsRotated] = useState(false);

  const history = useHistory();

  const handleItemClick = (e) => {
    console.log("what is this event", e);
    setActiveItemId(e.target.textContent);
    // history.push(path);

    toggleSidebar();
  };

  const handleToggle = () => {
    setIsRotated((prev) => !prev); // toggle rotation state
    toggleSidebar(); // still call external toggle
  };


  // const handleItemClick = (e, id) => {
  //   e.preventDefault();
  //   setActiveItemId(e, id);
  //   console.log("Clicked item ID:", id);
  // };

  return (
    <>
      <div className={rootStyle.adminwrapper}>
        <div className={appDetailStyle["admin-sidebar"]}>
          {/* <div className="logo">
            {Logo}
            <h2>Sageion</h2>
          </div> */}
          <div>
            <button
              // className={rootStyle.sidebarBack}
              className={`${rootStyle.sidebarBack} ${isRotated
                  ? rootStyle.rotateOpen
                  : rootStyle.rotateClosed
                }`}
              title="back"
              // onClick={toggleSidebar}
              onClick={handleToggle}

            >
              <GrFormNext size={20} className={rootStyle.backIc} />
            </button>
          </div>
          <div className={appDetailStyle.adminAppId}>
            <h3>Admin Portal</h3>
          </div>

          <div className={rootStyle["sidebarList-data"]}>
            <SidebarList
              items={adminItmList}
              onItemClick={(e) => handleItemClick(e)}
              activeItemId={activeItemId}
              appData={appData}
              setActiveItemId={setActiveItemId}
            // onItemClick={handleItemClick}
            // activeItemId={activeItemId}
            />
          </div>


        </div>
        <div className={appDetailStyle.apps}>
          <button
            className={appDetailStyle.btn}
            onClick={(e) => {
              history.push("/");
            }}
          >
            <TbCategory size={28} />
            Apps
          </button>
        </div>
      </div>
    </>
  );
};
